export default "__VITE_ASSET__BolaNDpB__"